// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1JNmn","selected":"styles_selected__2mtaw"};